import React from 'react';
import { createUseStyles } from 'react-jss';

interface EmptyListProps {
  title: string;
  subtitle: string;
}

const useStyles = createUseStyles({
  root: {
    position: 'relative',
    margin: '10px 0',
    minHeight: '135px',
  },
  cardBase: {
    position: 'absolute',
    boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.04)',
    border: '1px solid rgba(0, 0, 0, 0.05)',
    borderRadius: '10px',
    padding: '15px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    transition: 'box-shadow 0.2s ease, background-color 0.3s ease, border-color 0.3s ease',

    // Dark mode styles
    '@media (prefers-color-scheme: dark)': {
      border: '1px solid rgba(255, 255, 255, 0.1)',
      boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.3)',
    },
  },
  cardBottom: {
    top: 32,
    left: '16px',
    right: '16px',
    height: '100px',
    backgroundColor: '#f7f7f7',
    zIndex: 1,
    opacity: 0.4,

    // Dark mode styles
    '@media (prefers-color-scheme: dark)': {
      backgroundColor: '#222222',
      border: 'none',
    },
  },
  cardMiddle: {
    top: 16,
    left: '8px',
    right: '8px',
    height: '100px',
    backgroundColor: '#fafafa',
    zIndex: 2,
    opacity: 0.7,

    // Dark mode styles
    '@media (prefers-color-scheme: dark)': {
      backgroundColor: '#1f1f1f',
      border: 'none',
      opacity: 1,
    },
  },
  cardTop: {
    top: 0,
    left: 0,
    right: 0,
    height: '100px',
    backgroundColor: 'white',
    zIndex: 3,
    opacity: 1,

    // Dark mode styles
    '@media (prefers-color-scheme: dark)': {
      backgroundColor: '#1a1a1a',
    },
  },
  primaryText: {
    margin: '0 0 8px 0',
    fontSize: '16px',
    fontWeight: 600,
    color: '#282828',
    transition: 'color 0.3s ease',

    // Dark mode styles
    '@media (prefers-color-scheme: dark)': {
      color: '#ffffff',
    },
  },
  secondaryText: {
    margin: 0,
    fontSize: '14px',
    fontWeight: 400,
    color: '#666666',
    transition: 'color 0.3s ease',

    // Dark mode styles
    '@media (prefers-color-scheme: dark)': {
      color: '#b3b3b3',
    },
  },
});

const EmptyList: React.FC<EmptyListProps> = ({ title, subtitle }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={`${classes.cardBase} ${classes.cardBottom}`} />

      <div className={`${classes.cardBase} ${classes.cardMiddle}`} />

      <div className={`${classes.cardBase} ${classes.cardTop}`}>
        <p className={classes.primaryText}>{title}</p>
        <p className={classes.secondaryText}>{subtitle}</p>
      </div>
    </div>
  );
};

export default EmptyList;
